import React from "react";
import { FormularioDemo } from "../../components/solicitud-demo/components/FormularioDemo";
import { Helmet } from "react-helmet";
import { useTranslations } from "../../hooks/use-translations";
import { useLanguage } from "../../hooks/use-language";

/**
 * Componente que devuelve el formulario de demo para la pagina de contacto
 * @returns {JSX.Element} ContactDemoForm
 */
export const ContactDemoForm = () => {
    const lang = useLanguage();
    const textosTienda = useTranslations({ section: "tienda_makemake", lang: lang });

    return (
        <>
            <Helmet>
                <title>{textosTienda?.metadata?.demo?.title || 'MakeMake - Agendar demo'}</title>
                <meta name="description" content={textosTienda?.metadata?.demo?.description || 'Un agente de MakeMake te contactará para explicarte más sobre nuestros servicios'} />
            </Helmet>
            <div className="subsection pt-3">
                <FormularioDemo
                    lang={lang}
                    formDescription={textosTienda?.institucional?.demo?.descripcion || "Déjanos tus datos y un agente de MakeMake te contactará para explicarte más sobre nuestros servicios"}
                />
            </div>
        </>
    )
}